angular.module('survey')
  .directive('limitCheckboxes', function () {
    return {
      restrict: 'A',
      scope: {
        question: '=',
        checked: '=',
      },
      link: function (scope) {

        if (scope.question.selectedCount === undefined || scope.question.selectedCount === null) {
          scope.question.selectedCount = 0;
        }

        if (scope.checked) {
          scope.question.selectedCount++;
        }

        // Watching the bound model (rather than a DOM change event) keeps the
        // count accurate no matter how `checked` gets flipped -- a direct
        // checkbox click, or the option's text-entry field setting it via
        // ng-click, which never fires a native change event on the checkbox.
        scope.$watch('checked', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }

          scope.question.selectedCount += newVal ? 1 : -1;
        });

        /** when a user encounters a checkbox question with a limit, they should only be able to check as many boxes as the limit allows
         * This directive will validate the number of checked boxes against the limit set in the question's limit_checkboxes property.
         * If the number of checked boxes exceeds the limit, it will alert the user and prevent further checks.
         * If the limit is 0, it will not enforce any limit.
         * If the limit is equal to the number of options, it will not enforce any limit
         * This directive should be used on checkbox questions where the limit_checkboxes property is set.
         * It will watch the ngModel for changes and validate the number of checked boxes against the limit.
         * it will disbale the rest of the checboxes in that group if the user has already met the limit
         * boxes will be enabled if the user rremoves a check from one of the boxes
         * the limit checboxes will render a text saying hwo many options are available and how many are checked
         */
      }
    }
  })
